export const SAVED_VIEWS_STALE_TIME: number = 60 * 1000
export const SAVED_VIEWS_ORDER_KEY = 'saved-views-order'
